import React, { Component } from "react";
import {Link} from "react-router-dom";

export default class BannerSimple extends Component {
    render() {

        let { title, boxElement } = this.props;

        return (
            <>
                {/* start banner Area */}
                <section className="banner-area relative">
                    <div className="container">
                        <div className="row d-flex align-items-center justify-content-center">
                            <div className="about-content col-lg-12">
                                <h1 className="text-white">
                                    { title ? title : "Title" }
                                </h1>
                                <p className="link-nav">
                                    <span className="box">
                                        { boxElement && Array.isArray(boxElement) ? boxElement.map((rows, keys) => <Link to={ rows.link ? rows.link : "#" } key={ keys }>{ rows.name ? rows.name : "element" } </Link>) : <Link to="/">Index </Link> }
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                {/* End banner Area */}
            </>
        );
    }
}
